import { Link } from "react-router-dom";
import phone from "../../assets/icons/phone.png";
import XsFooter from "./XsFooter";
import { FOOTER } from "../../data/texts";
import { ENDPOINTS } from "../../api/main-page-endpoints";
import { useEffect, useState } from "react";
import axios from "axios";

const Footer = () => {
  const data = FOOTER;
  const logos = data.logos;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // منو
  const [footerMenu, setFooterMenu] = useState([]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);

        const response = await axios.get(ENDPOINTS.FOOTER_MENU);

        if (response.data && response.data.status === "success") {
          setFooterMenu(response.data.data);
        }
      } catch (err) {
        console.error("خطا در دریافت اطلاعات:", err);
        setError("خطایی در بارگذاری اطلاعات رخ داده است.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  const getValidRoute = (apiUrl) => {
    const urlStr = String(apiUrl).toLowerCase();

    if (urlStr.includes("about")) return "/aboutus";
    if (urlStr.includes("contact")) return "/contactus";
    if (urlStr.includes("doctor")) return "/doctors";
    if (urlStr.includes("center")) return "/centers";

    return urlStr.startsWith("/") ? urlStr : `/${urlStr}`;
  };

  return (
    <div className="pb-[70px] sm:pb-[60px] md:pb-[40px] lg:pb-[0px] ">
      <div className="hidden md:flex justify-center bg-[#e5e5e5] py-[30px] lg:py-0">
        <div className="md:w-[85%]">
          <div className="py-[30px] my-5 grid grid-cols-5 gap-2 items-center">
            {/* لوگو */}
            <div className="col-span-1">
              <img src={data.logo} alt="logo" />
            </div>

            {/* بخش راست و چپ */}
            <div className="col-span-4 ps-10 xl:ps-20 items-center">
              {/* تغییر گرید به ۲ ستونه برای تقسیم بهتر فضا و تراز چپ و راست */}
              <div className="grid grid-cols-2 gap-8 items-center">
                
                {/* ستون راست: منو و متن توضیحات */}
                <div className="flex flex-col items-start gap-3">
                  {/* منو */}
                  <div className="flex flex-wrap gap-x-6 gap-y-3">
                    {footerMenu.map((m) => (
                      <Link
                        key={m.id}
                        to={getValidRoute(m.url)}
                        className="hover:text-aqua transition-colors"
                      >
                        {m.title}
                      </Link>
                    ))}
                  </div>

                  {/* متن */}
                  <div className="text-right">
                    <p className="text-[12px] xl:text-[14px] text-[#858585] leading-7">
                      {data.text}
                    </p>
                  </div>
                </div>

                {/* ستون چپ: تماس و اینماد (کاملا چسبیده به چپ) */}
                <div className="flex flex-col items-end w-full">
                  {/* دکمه تماس */}
                  <div className="flex items-center gap-2 bg-white ps-3
                   rounded-full text-[#858585] shadow-sm text-[14px]">
                    <a className="text-gray-900" href={`tel:${data.number1}`}>{data.number1}</a>
                    <span>و</span>
                    <a className="text-gray-900" href={`tel:${data.number2}`}>{data.number2}</a>
                    <span className="bg-aqua rounded-full p-2 flex items-center justify-center">
                      <img src={phone} width={15} alt="phone" />
                    </span>
                  </div>

                  {/* لوگوهای اعتماد */}
                  <div className="flex gap-2 mt-3 justify-end">
                    {logos.map((e, index) => (
                      <Link key={index} to={e.link}>
                        <img
                          src={e.logo}
                          className="object-cover h-12 w-12 rounded-lg"
                          alt="logo"
                        />
                      </Link>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <XsFooter menuData={footerMenu} />
    </div>
  );
};

export default Footer;
